import { render, staticRenderFns } from "./Regra.vue?vue&type=template&id=20229492&scoped=true"
import script from "./Regra.vue?vue&type=script&lang=js"
export * from "./Regra.vue?vue&type=script&lang=js"
import style0 from "./Regra.vue?vue&type=style&index=0&id=20229492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20229492",
  null
  
)

export default component.exports